module.exports = __webpack_public_path__ + "img/signature.8e4c8322.svg";